import { ScreenSize, ScreenSizesEnum } from "@contracts/screenSize";

export function getSingleSocialPreviewMediaMaxHeight(screenSize: ScreenSize): string {
  switch (screenSize) {
    case ScreenSizesEnum.Desktop:
    case ScreenSizesEnum.Laptop:
    case ScreenSizesEnum.Mobile:
      return "250px";
    case ScreenSizesEnum.Tablet:
      return "200px";
    default:
      return "300px";
  }
}
